import React from "react";
import { Button as BSButton, Glyphicon } from "react-bootstrap";
import { v4 as uuid } from "uuid";
import { classNames } from "./utils/classNames";
import { useButtonClasses } from "./Button/Button.styles";
import { useUtilityStyles } from "./hooks/useUtilityStyles";
import { Tooltip } from "./Tooltip";
export var BUTTON_TYPE_STYLES = {
    primary: "primary",
    default: "default",
    suppressed: "link",
};
export var Button = function (_a) {
    var label = _a.label, icon = _a.icon, disabled = _a.disabled, disabledTooltipContent = _a.disabledTooltipContent, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, _c = _a.preventDefault, preventDefault = _c === void 0 ? true : _c, _d = _a.stopPropagation, stopPropagation = _d === void 0 ? true : _d, _e = _a.type, type = _e === void 0 ? "default" : _e, _f = _a.key, key = _f === void 0 ? "" : _f, componentClass = _a.componentClass, ariaLabel = _a.ariaLabel, id = _a.id, className = _a.className, dataId = _a.dataId, dataTestId = _a.dataTestId, dataHook = _a.dataHook, block = _a.block, styleOptions = _a.styleOptions;
    var classes = useButtonClasses(type, block);
    var utilityStyles = useUtilityStyles(styleOptions);
    var handleClick = React.useCallback(function (e) {
        if (preventDefault) {
            e.preventDefault();
        }
        if (stopPropagation) {
            e.stopPropagation();
        }
        if (onClick)
            onClick(e);
    }, [onClick, preventDefault, stopPropagation]);
    var button = (React.createElement(BSButton, { onClick: handleClick, disabled: disabled, bsStyle: BUTTON_TYPE_STYLES[type], key: key, componentClass: componentClass, "aria-label": ariaLabel, id: id, className: classNames(classes.button, className, utilityStyles.utilities), "data-id": dataId, "data-testid": dataTestId, "data-hook": dataHook },
        icon && React.createElement(Glyphicon, { glyph: icon }),
        (icon && " ".concat(label)) || label));
    return !disabled || !disabledTooltipContent ? (button) : (React.createElement(Tooltip, { content: disabledTooltipContent, tooltipId: "button-".concat(id || uuid(), "-tooltip"), iconShown: false }, button));
};
